import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, TextField } from 'components'

const UrlPreview = ({
    defaultValue,
    onChange,
    isDisabled,
    ...props
}) => {
    const [value, setValue] = useState(defaultValue);

    const handleChange = (event) => {
        setValue(event.target.value);
        onChange(event.target.value);
    };

    return (
        <FormControl fullWidth>
            <TextField
                fullWidth
                disabled={isDisabled}
                value={value}
                onChange={handleChange}
                { ...props }
            />
        </FormControl>
    );
};

UrlPreview.propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    isDisabled: PropTypes.bool
};

UrlPreview.defaultProps = {
    defaultValue: '',
    onChange: () => {},
    isDisabled: false
};

export default UrlPreview;
